import { render, staticRenderFns } from "./DetailTicketAppDialog.vue?vue&type=template&id=5679a128&scoped=true"
import script from "./DetailTicketAppDialog.vue?vue&type=script&lang=js"
export * from "./DetailTicketAppDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailTicketAppDialog.vue?vue&type=style&index=0&id=5679a128&lang=css"
import style1 from "./DetailTicketAppDialog.vue?vue&type=style&index=1&id=5679a128&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5679a128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5679a128')) {
      api.createRecord('5679a128', component.options)
    } else {
      api.reload('5679a128', component.options)
    }
    module.hot.accept("./DetailTicketAppDialog.vue?vue&type=template&id=5679a128&scoped=true", function () {
      api.rerender('5679a128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ticketApp/DetailTicketAppDialog.vue"
export default component.exports